<h2 class="text-xl font-bold">Payment Method Availability</h2>

<div class="flex flex-col gap-4">
  <pr-information-box>
    Configure which payment methods are available for patients through online
    bookings and the AI receptionist. Set patient-friendly names that will be
    displayed, instead of internal system names.
  </pr-information-box>

  <ng-container *ngrxLet="providerRows$; let providers">
    <mat-list>
      @for (row of providers; track row.key) {
        <mat-list-item class="!h-auto">
          <div class="flex w-full flex-1 flex-row items-center gap-4 py-2">
            <mat-checkbox
              [checked]="row.isSelected"
              (change)="toggleProvider(row, $event.checked)"
            />
            <div class="w-[30%] font-medium">
              <span [textContent]="row.label"></span>
              @if (row.isManual) {
                <small class="block text-xs font-normal opacity-60">
                  Manual Transaction Type
                </small>
              }
            </div>
            <mat-form-field subscriptSizing="dynamic" class="w-full flex-1">
              <mat-label>Patient-friendly name</mat-label>
              <input
                matInput
                [value]="row.patientFriendlyName"
                [disabled]="!row.isSelected"
                (input)="updatePatientFriendlyName(row, $event)"
              />
            </mat-form-field>
          </div>
        </mat-list-item>
      }
    </mat-list>
  </ng-container>

  <form class="flex flex-col gap-4" [formGroup]="form">
    <h2 class="text-xl font-bold">Insurance Funds Accepted</h2>
    <mat-form-field>
      <mat-chip-grid
        #insuranceFundsGrid
        formControlName="insuranceFundsAccepted"
      >
        @for (
          item of form.controls.insuranceFundsAccepted.value ?? [];
          track item
        ) {
          <mat-chip-row (removed)="removeInsuranceFund(item)">
            <span [textContent]="item"></span>
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input
        matInput
        placeholder="Add an insurance fund..."
        [matChipInputFor]="insuranceFundsGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addInsuranceFund($event)"
      />
    </mat-form-field>

    <h2 class="text-xl font-bold">Government Programs</h2>
    <mat-form-field>
      <mat-chip-grid
        #governmentProgramsGrid
        formControlName="governmentPrograms"
      >
        @for (
          item of form.controls.governmentPrograms.value ?? [];
          track item
        ) {
          <mat-chip-row (removed)="removeGovernmentProgram(item)">
            <span [textContent]="item"></span>
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input
        matInput
        placeholder="Add a government program..."
        [matChipInputFor]="governmentProgramsGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addGovernmentProgram($event)"
      />
    </mat-form-field>

    <h2 class="text-xl font-bold">Payment Plan Descriptions</h2>
    <mat-form-field>
      <textarea
        matInput
        formControlName="paymentPlanDescriptions"
        rows="4"
      ></textarea>
    </mat-form-field>
  </form>

  <pt-buttons-container>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
  </pt-buttons-container>
</div>
